<div class="under-construction-container">
  <span>We are</span>
  <img src="assets/img/vx-anagrama.png">
  <h2>We're working on it</h2>
</div>